import { NgxMatDateFormats } from '@angular-material-components/datetime-picker';
import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import { DatePipe } from '@angular/common';
import { Inject, Optional } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';

/**
 * Формат даты
 */
export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    },
    display: {
        dateInput: 'customInput',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

/**
 * Формат даты
 */
export const CUSTOM_YEAR_MONTH_FORMATS = {
    parse: {
        dateInput: 'MM.YYYY',
    },
    display: {
        dateInput: 'shortInput',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

/**
 * Формат даты
 */
export const CUSTOM_YEAR_FORMATS = {
    parse: {
        dateInput: 'YYYY',
    },
    display: {
        dateInput: 'yearInput',
        monthYearLabel: { year: 'numeric' },
        dateA11yLabel: { year: 'numeric' },
        monthYearA11yLabel: { year: 'numeric' },
    },
};
export const CUSTOM_DATETIME_FORMATS: NgxMatDateFormats = {
    parse: {
        dateInput: 'l, LTS',
    },
    display: {
        dateInput: 'l, LTS',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

/**
 * Класс парсер даты
 */
export class CustomDatePickerAdapter extends MomentDateAdapter {
    /**
     * Конструктор
     * @param dateLocale локать
     */
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string = 'ru') {
        super(dateLocale);
        moment.locale(dateLocale);
    }

    /**
     * Парсер даты
     * @param value значение
     * @param parseFormat формат
     */
    parse(value: any, parseFormat: string | string[]): Moment | null {
        try {
            if (!value || (typeof value === 'string' && value.indexOf('_') > -1)) {
                return null;
            }
            let m = null;
            try {
                m = moment.utc(value, parseFormat, true);
            } catch (e) {}
            if (!m || !m.isValid()) {
                try {
                    m = moment.utc(value, moment.localeData().longDateFormat('L'));
                } catch (e) {}
            }
            if (!m || !m.isValid()) {
                try {
                    m = moment.utc(value);
                } catch (e) {}
            }
            if (m && m.isValid()) {
                m.hour(12).minute(0).second(0).add(moment().utcOffset(), 'm').utc(false);
                const result = moment([m.year(), m.month(), m.date()]);
                result.add(12, 'hours').add(moment().utcOffset(), 'm').utc(false);
                return result;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    }

    /**
     * Преобразование формата вывода даты
     * @param date дата
     * @param displayFormat формат
     */
    format(date: Moment, displayFormat: string): string {
        const fullDate: any = date;
        if (displayFormat === 'customInput') {
            return new DatePipe(this.locale).transform(fullDate, 'shortDate');
        } else if (displayFormat === 'shortInput') {
            return new DatePipe(this.locale).transform(fullDate, 'MM.yyyy');
        } else if (displayFormat === 'yearInput') {
            return new DatePipe(this.locale).transform(fullDate, 'yyyy');
        } else if (displayFormat === 'customDateTimeInput') {
            return new DatePipe(this.locale).transform(fullDate, 'dd.mm.yyyy h:mm');
        } else {
            return new DatePipe(this.locale).transform(fullDate, 'MMM yyyy');
        }
    }
}

/**
 * Класс парсер даты
 */
export class CustomDateTimePickerAdapter extends NgxMatMomentAdapter {
    /**
     * Конструктор
     * @param dateLocale локать
     */
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string = 'ru') {
        super(dateLocale);
        moment.locale(dateLocale);
    }

    /**
     * Парсер даты
     * @param value значение
     * @param parseFormat формат
     */
    parse(value: any, parseFormat: string | string[]): Moment | null {
        try {
            if (!value || (typeof value === 'string' && value.indexOf('_') > -1)) {
                return null;
            }
            let m = null;
            try {
                m = moment.utc(value, parseFormat, true);
            } catch (e) {}
            if (!m || !m.isValid()) {
                try {
                    m = moment(value, 'DD-MM-YYYY HH:mm');
                } catch (e) {}
            }
            if (!m || !m.isValid()) {
                try {
                    m = moment.utc(value);
                } catch (e) {}
            }
            if (m && m.isValid()) {
                return m;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    }

    /**
     * Преобразование формата вывода даты
     * @param date дата
     * @param displayFormat формат
     */
    format(date: Moment, displayFormat: string): string {
        const fullDate: any = date;
        if (displayFormat === 'l, LTS') {
            return new DatePipe(this.locale).transform(fullDate, 'dd.MM.yyyy HH:mm');
        } else {
            return new DatePipe(this.locale).transform(fullDate, 'MMM yyyy');
        }
    }
}
